import { render } from "./TableSearch.vue?vue&type=template&id=6915e6bc"
import script from "./TableSearch.vue?vue&type=script&lang=js"
export * from "./TableSearch.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__